import SectionShell from "@/pages/home/components/SectionShell";
import { gallery, siteName } from "@/mocks/home";

export default function GallerySection() {
  return (
    <SectionShell
      id="gallery"
      num="04"
      eyebrow="STILLS GALLERY"
      title="剧照陈列：先看画面，再看故事"
      desc="六张大图卡片来自片中关键场景，色调统一、留白充足，适合先扫一眼整体气质。"
      tone="tint"
    >
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 lg:gap-5">
        {gallery.map((shot, idx) => (
          <figure
            key={shot.id}
            className={[
              "group relative overflow-hidden rounded-xl border border-background-200/70 bg-background-50",
              idx === 0 ? "sm:col-span-2 lg:col-span-1" : "",
            ].join(" ")}
          >
            <div className="relative aspect-[16/10] w-full">
              <img
                src={shot.image}
                alt={`${siteName} 剧照 ${shot.caption}`}
                title={`${siteName} ${shot.caption} 高清剧照`}
                className="h-full w-full object-top object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/75 via-foreground-950/5 to-transparent" />
              <figcaption className="absolute inset-x-0 bottom-0 flex items-center gap-2 p-4">
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-accent-500 text-[11px] font-bold text-background-50">
                  {shot.id}
                </span>
                <span className="text-sm font-medium text-background-50">{shot.caption}</span>
              </figcaption>
            </div>
          </figure>
        ))}
      </div>
    </SectionShell>
  );
}